export default "__VITE_ASSET__bdf76826__"